import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzResizableModule } from 'ng-zorro-antd/resizable';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { HdButtonGroupModule } from '../hd-button-group/hd-button-group.module';
import { HdButtonModule } from '../hd-button/hd-button.module';
import { HdSpaceModule } from '../hd-space/hd-space.module';
import { HdStatusModule } from '../hd-status/hd-status.module';
import { CommonSessionService } from '../service/common-session.service';
import { HdTableCellPipe } from './hd-table-cell.pipe';
import { HdTableComponent } from './hd-table.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgZorroAntdModule,
    NzTableModule,
    HdSpaceModule,
    HdStatusModule,
    HdButtonModule,
    HdButtonGroupModule,
    NzToolTipModule,
    NzPopconfirmModule,
    NzResizableModule,
    NzDropDownModule,
    NzTreeModule,
    NzIconModule
  ],
  declarations: [HdTableComponent, HdTableCellPipe],
  providers: [CommonSessionService],
  exports: [HdTableComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class HdTableModule { }
